export const LOAD_CART = 'LOAD_CART';
export const LOAD_CART_SUCCESS = 'LOAD_CART_SUCCESS';
export const PENDING_CART_OPERATION = 'PENDING_CART_OPERATION';
export const PENDING_CART_OPERATION_SUCCESS = 'PENDING_CART_OPERATION_SUCCESS';
export const PENDING_QUANTITY_UPDATE = 'PENDING_QUANTITY_UPDATE';
export const EMPTY_CART = 'EMPTY_CART';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART';
export const SET_FULL_ASSET_INFO = 'SET_FULL_ASSET_INFO';
